import { useTranslation } from "react-i18next";
import PageBanner from "../../../Shared/PageBanner";
import bannerBg from "../../../assets/img/Banner/Top-Image8.jpg";
import TopicContent from "./TopicContent";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useFetchGeneralSettingQuery } from "../../../app/feature/API/Helpers";

const Topics = () => {
  const {i18n} = useTranslation()
  const navigate = useNavigate();
  const { data: GeneralSetting } = useFetchGeneralSettingQuery();
  const knowledge_base_page_show = GeneralSetting?.map((e)=>e?.knowledge_base_page_show)

  useEffect(() => {

    if (Number(knowledge_base_page_show)===0) {
      navigate("/");
    }
  }, [knowledge_base_page_show, navigate]);
  return (
    <>
      <PageBanner title={`${i18n.language==='en'?"Topics":"المواضيع"}`} bannerBg={bannerBg} currentPage={`${i18n.language==='en'?"Topics":"المواضيع"}`} />
      <TopicContent/>
    </>
  );
};

export default React.memo(Topics);
